import * as React from 'react'
// libs
import styled from 'styled-components'
import { WrappedFieldArrayProps } from 'redux-form'
// components
import { ReduxSelect } from 'components/FormElements/ReduxForm'
// constants
import { CONDITION_TYPE_OPTIONS } from 'constants/systemProcesses'
// themes
import { colors } from 'themes'
// view components
import SubCondition from './components/SubCondition'
// views
import { AddButton, CloseIcon, ConditionWrapper } from 'components/Modals/SystemProcessModal/Form/components/views'

// styled
const Wrapper = styled('div')`
  background-color: ${colors.gray190};
  border-radius: 4px;
  padding: 0 0 0 16px;
`

// types
interface IIncomingProps {
  removeSubField: () => void
  groupIndex: number
}

const renderSubConditions: React.FC<WrappedFieldArrayProps<any> & IIncomingProps> = ({
  fields,
  removeSubField,
  groupIndex
}) => {
  return (
    <>
      <CloseIcon
        data-testid='system-process-remove-condition-group'
        data-entity-id={groupIndex}
        onClick={removeSubField}
        iconSize={24}
      />
      <Wrapper data-testid='system-process-condition-group' data-entity-id={groupIndex}>
        {fields.map((field, index) => {
          const removeField = () => fields.remove(index)

          return (
            <React.Fragment key={field}>
              <SubCondition field={field} groupIndex={groupIndex} index={index} removeField={removeField} />

              {fields.length - index >= 2 && (
                <ConditionWrapper marginLeft={62}>
                  <ReduxSelect name={`${field}.conditionType`} options={[CONDITION_TYPE_OPTIONS[1]]} placeholder={''} />
                </ConditionWrapper>
              )}
            </React.Fragment>
          )
        })}

        <AddButton
          data-testid='system-process-add-condition'
          data-entity-id={groupIndex}
          onClick={() => fields.push({ conditionType: CONDITION_TYPE_OPTIONS[1] })}>
          + add a condition to this group
        </AddButton>
      </Wrapper>
    </>
  )
}

export default renderSubConditions
